/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneButton as ResolvedStandaloneButton } from 'base/components/standalone/Button';

export const Button: typeof ResolvedStandaloneButton = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneButton {...props} />
        </ErrorBoundary>
    );
});

export type ButtonProps = PropsFromComponent<typeof Button>;

/** @deprecated Use slot architecture instead */
export const ButtonWith = (extras: DynamicStandaloneExtras): typeof Button => {
    return function Button(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Button');
        return <ResolvedStandaloneButton {...mergeProps({ options: { theme } }, props)} />;
    }
}